import * as ngCore from '@angular/core'

import * as state from '../../../../state'

import * as conversational from './conversational'
import * as switcher from './switcher'

/**
 * Assistant slide-out panel component.
 */
@ngCore.Component({
  imports: [conversational.Component, switcher.Component],
  selector: 'atn-assistant',
  styleUrls: ['./component.scss'],
  templateUrl: './component.html',
})
export class Component {
  /** @see {@link state.assistants.Assistants} */
  public readonly assistants = ngCore.inject(state.assistants.Assistants)

  /** Whether the assistant should render its wide, fullscreen layout. */
  public readonly fullScreenSg = ngCore.input(false, { alias: 'fullScreen' })
}
